// @ts-nocheck
import { useState } from "react";
import { PageHeader } from "../components/layout/PageHeader";
import { useLang } from "../lib/lang";

export function Profile() {
  const { t } = useLang();
  const d = t.profile;

  const [name, setName] = useState("John Doe");
  const [email, setEmail] = useState("john@example.com");
  const [saved, setSaved] = useState(false);

  const handleSave = (e: React.FormEvent) => {
    e.preventDefault();
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  return (
    <div>
      <PageHeader title={d.title} />
      <div className="px-6 pb-6">
        <div className="max-w-2xl space-y-6">
          {saved && (
            <div className="bg-[#d4edda] border border-[#c3e6cb] text-[#155724] px-4 py-3 rounded-lg text-sm flex items-center gap-2">
              <i className="fas fa-check-circle" />{d.saved}
            </div>
          )}

          <div className="bg-white rounded-xl shadow-sm border border-[#e9ecef]">
            <div className="px-6 py-4 border-b border-[#e9ecef]">
              <h4 className="text-sm font-semibold text-[#32325d]">{d.personalInfo}</h4>
            </div>
            <form onSubmit={handleSave} className="p-6 space-y-4">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 rounded-full gradient-primary flex items-center justify-center text-white text-2xl font-bold">
                  {name.charAt(0).toUpperCase()}
                </div>
                <div>
                  <p className="text-sm font-semibold text-[#32325d]">{name}</p>
                  <p className="text-xs text-[#8898aa]">{email}</p>
                  <button type="button" className="text-xs text-[#1171ef] hover:underline mt-1">{d.changePhoto}</button>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-semibold text-[#525f7f] mb-1.5">{d.fullName}</label>
                  <input value={name} onChange={e => setName(e.target.value)} className="w-full border border-[#cad1d7] rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#1171ef]/30 focus:border-[#1171ef]" />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-[#525f7f] mb-1.5">{d.email}</label>
                  <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full border border-[#cad1d7] rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#1171ef]/30 focus:border-[#1171ef]" />
                </div>
              </div>
              <div>
                <label className="block text-xs font-semibold text-[#525f7f] mb-1.5">{d.phone}</label>
                <input type="tel" className="w-full border border-[#cad1d7] rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#1171ef]/30 focus:border-[#1171ef]" placeholder="+1234567890" />
              </div>
              <div className="flex justify-end">
                <button type="submit" className="gradient-primary text-white px-6 py-2 rounded-lg text-sm font-medium shadow-sm hover:opacity-90">{d.saveChanges}</button>
              </div>
            </form>
          </div>

          <div className="bg-white rounded-xl shadow-sm border border-[#e9ecef]">
            <div className="px-6 py-4 border-b border-[#e9ecef]">
              <h4 className="text-sm font-semibold text-[#32325d]">{d.changePassword}</h4>
            </div>
            <div className="p-6 space-y-4">
              {[d.currentPassword, d.newPassword, d.confirmPassword].map(label => (
                <div key={label}>
                  <label className="block text-xs font-semibold text-[#525f7f] mb-1.5">{label}</label>
                  <input type="password" className="w-full border border-[#cad1d7] rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#1171ef]/30 focus:border-[#1171ef]" placeholder="••••••••" />
                </div>
              ))}
              <div className="flex justify-end">
                <button className="gradient-primary text-white px-6 py-2 rounded-lg text-sm font-medium shadow-sm hover:opacity-90">{d.updatePassword}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
